import React from 'react';

import { Flex, Typography } from 'antd';

interface IProps {
  city: string | null;
  address: string | null;
}

export const DeliveryAddress: React.FC<IProps> = ({ city, address }) => {
  if (!city && !address) {
    return <>—</>;
  }

  return (
    <Flex vertical>
      {city && <Typography.Text strong>{city}</Typography.Text>}
      {address && (
        <Typography.Text type="secondary" style={{ fontSize: 13 }}>
          {address}
        </Typography.Text>
      )}
    </Flex>
  );
};
